import { render, staticRenderFns } from "./procurementGreen.vue?vue&type=template&id=467679c0&scoped=true"
import script from "./procurementGreen.vue?vue&type=script&lang=js"
export * from "./procurementGreen.vue?vue&type=script&lang=js"
import style0 from "./procurementGreen.vue?vue&type=style&index=0&id=467679c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467679c0",
  null
  
)

export default component.exports